import { useState } from 'react';
import { toast } from 'sonner';
import { businessInfo } from '../mock';
import { logError } from '../lib/logger';

const INITIAL_FORM = {
  name: '', email: '', phone: '',
  service_type: '', firearm_type: '',
  description: '', timeline: '',
};

export function useQuoteSubmit(onClose) {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const apiUrl = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${apiUrl}/api/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      toast.success('Quote request received!', {
        description: "Thank you for your interest. We'll review your request and contact you within 24 hours.",
      });
      setFormData(INITIAL_FORM);
      if (onClose) setTimeout(() => onClose(), 2000);
    } catch (err) {
      logError('Quote submit failed:', err);
      toast.error('Failed to submit quote request', {
        description: 'Please try again or call us directly at ' + businessInfo.phone,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { formData, isSubmitting, handleInputChange, handleSubmit };
}
